import { useState } from "react";
import { getWebStorage } from "@/common/utils/storage";

const SIDEBAR_COLLAPSED_STORAGE_KEY = "desktopSidebarCollapsed";
const COLLAPSED_VALUE = "true";
const EXPANDED_VALUE = "false";

/**
 * Desktop sidebar collapse preference, shared by every layout under one key.
 * Read synchronously from web storage in the initializer (the async `Storage`
 * wrapper would render the expanded sidebar first and then flash to collapsed).
 */
export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(
    () =>
      getWebStorage()?.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) ===
      COLLAPSED_VALUE,
  );

  const toggleCollapsed = () => {
    const next = !collapsed;
    setCollapsed(next);
    try {
      getWebStorage()?.setItem(
        SIDEBAR_COLLAPSED_STORAGE_KEY,
        next ? COLLAPSED_VALUE : EXPANDED_VALUE,
      );
    } catch {
      // Storage can be full or blocked; the preference just won't persist.
    }
  };

  return { collapsed, toggleCollapsed };
}
